import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.css';

import App from './App';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      if (!registration.scope.includes('/api/v1/ext/')) {
        registration.unregister();
      }
    }
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
